import React,{Component} from 'react';
import "./maincontainer.css";
import { Col, Container, Row, Nav,Form } from 'bootstrap-4-react';
import {ResponsiveLine} from '@nivo/line';
import moment from 'moment'


class MainContainer extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      data: [],
      groupBy: 'sucursal',
      finit: moment().format('YYYY-MM-DD'),
      finit_inventario: moment().format('YYYY-MM-DD'),
      // finit: '2021-09-01',
      ffin: moment().format('YYYY-MM-DD'),
      arrHistoryCaja: [],
      arrDiasVenta: [],
      arrDiasGasto: [],
      arrHistoryVentas: [],
      arrHistoryProductosVenta: [],
      arrCategorias: [],
      arrCategoriasInventario: [],
      viewTableType: 'KG/PZA.',
      totalVentas: {
        kg: 0,
        pesos: 0,
        pesosMesAnterior: 0,
      },
      arrFiltroVer: [
        { optFiltroVer: 'dia', value: 'Día', active: 1, },
        { optFiltroVer: 'semana', value: 'Semana', active: 0, },
        { optFiltroVer: 'mes', value: 'Mes', active: 0, },
      ],

      arrRegisterCaja: {
        date: moment().format('YYYY-MM-DD'),
        concepto: 0,
        cantidad: '',
        observacion: '',
      },
      arrCategoriasFilter: [],
    }
  }

  componentDidMount() {
    this.getInfo()
  }

  getInfo() {
    const { date, arrDiasVenta, finit, ffin, groupBy, } = this.state
    
    fetch(this.getURLByOPT('getListadoVentaByDiaV2'), this.headersPOST({ date, groupBy, finit, ffin, }))
    .then(response => response.json())
    .then((response) => {
      let { categorias, productos, arrHistoryVentas, arraySucursales, arrDiasVenta, arrDiasGasto, arrHistoryCaja, confirmados, pendientes, arrHistoryProductosVenta, } = response
      let { total_pesos, total_kg, total_pesos_before, } = arrDiasVenta

      this.setState({
        arrHistoryVentas,
        arraySucursales,
        arrDiasVenta: arrDiasVenta.array,
        arrHistoryCaja,
        totalVentas: {
          kg: total_kg,
          pesos: total_pesos,
          pesosMesAnterior: total_pesos_before,
        },
        isLoading: false,

        data: [
          {
            "id": "ventas",
            "color": "hsl(134, 70%, 50%)",
            data: [...arrDiasVenta.array],
          }, {
            id: 'france',
            "color": "hsl(59, 70%, 50%)",
            data: [...arrDiasVenta.arrDiasGasto],
          },
        ],
        arrHistoryProductosVenta,
      })

    }).catch((error) => console.log(error));


    this.setState({ arrStock: [], arrCategorias: [], })
    const { optTypeView, id_sucursal } = this.state
    let opt;
    if (optTypeView === 'm')
      opt = 'month'
    else
      opt = 'day'

    fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp?opt=getStockAlmacen", this.headersPOST({ fecha_init : this.state.finit, fecha_fin: this.state.ffin }))
    .then(response => response.json())
    .then((response) => {
      let { productos, categorias, venta, gasto_venta, venta_citas, gasto_citas, venta_mes, venta_citas_mes} = response
      let gral_day_compra_pesos = 0, gral_day_venta_pesos = 0, gral_existencia_kg = 0,
      gral_existencia_pesos = 0, gral_day_venta_pesos_citas = 0

      productos.map((t) => {
        // cantidadDisponible += ( t.valor * -1 )
        gral_existencia_kg = (((t.compra_kg - t.venta_kg) - t.salida_kg) + gral_existencia_kg)
        gral_existencia_pesos = (((t.compra_pesos - t.venta_pesos) - t.salida_pesos) + gral_existencia_pesos)
        gral_day_compra_pesos = (t.day_compra_pesos + gral_day_compra_pesos)
        // gral_day_venta_pesos = (t.day_venta_pesos + gral_day_venta_pesos)

        if (t.type === 9) {
          gral_day_venta_pesos_citas = (t.day_venta_pesos + gral_day_venta_pesos_citas)
        } else {
          gral_day_venta_pesos = (t.day_venta_pesos + gral_day_venta_pesos)
        }

      })

      let totalEgresoDia = gral_day_compra_pesos
      let totalIngresoDia = gral_day_venta_pesos
      let totalIngresoDiaCitas = gral_day_venta_pesos_citas
      this.setState({
        arrCategorias: categorias, arrStock: productos, totalEgresoDia, totalIngresoDia, totalIngresoDiaCitas,
        totalDisponibleVentaGlobal: venta_mes,
        totalDisponibleCitasGlobal: venta_citas_mes,

        totalGastoVentaGlobal: response.gasto_venta_mes,
        totalGastoCitasGlobal: response.gasto_citas_mes,

        totalGastoVentaDia: response.gasto_venta_dia,
        totalGastoCitasDia: response.gasto_citas_dia,

      })
    })


  }

  getURLByOPT(opt) {
    let PHP = this.props.initState.debug === 1 ? 'controllerPreproduction.php' : 'controllerWebApp.php'
    return `https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/${PHP}?opt=${opt}`
  }


  render() {
    const { data, arraySucursales, date, totalVentas, isLoading, groupBy, arrHistoryCaja, arrHistoryVentas, arrFiltroVer, finit, ffin, valueLarge,
      arrTraspasosPendientes, indexTraspasoView, indexConfirmadosView, arrTraspasosConfirmados, 
      arrHistoryProductosVenta, arrRegisterCaja, viewRegisterCaja,
      arrCategorias, valSeach, viewTableType, arrCategoriasFilter,
      arrCategoriasInventario, finit_inventario, updateInventory,
    } = this.state
    const { openMenu, module, } = this.props.initState;

    let cantidadDisponible = 0,
      cantidadSalidaDinero = 0,
      cantidadSalidaDineroCitas = 0

    arrHistoryCaja.map((t) => {
      if (t.id_motivo == 4) {
        cantidadSalidaDinero += parseFloat(t.valor) 
      } else if (t.id_motivo == 5) {
        cantidadSalidaDineroCitas += parseFloat(t.valor) 
      } else {
        cantidadDisponible += (t.valor * -1)
      }
    })

    // let arrCategoriasFilter = [], arrCitasFilter = [];

    // arrCategorias.map((t,e) => {
    //   if(t.id_categoria !== '60ae75a798d59') {
    //     arrCategoriasFilter.push(t)
    //   } else {
    //     arrCitasFilter.push(t)
    //   }
    // })

    return(
      <div className={`main-container ${(openMenu) ? 'wrapper-left' : ''}`} >
        <h1 className="ws-title-main mb-4">Dashboard</h1>
        <Nav pills>
          <Nav.ItemLink active={(module==='dashboard') ? true : false} href="#"
          onClick={
            (e) => {
              this.initsetState({
                module:'dashboard'
              })
            }
          }
          >General</Nav.ItemLink>
          <Nav.ItemLink href="#" active={(module==='tienda') ? true : false}
          onClick={
            (e) => {
              this.initsetState({
                module:'tienda'
              })
            }
          }
          >Tienda</Nav.ItemLink>
          <Nav.ItemLink href="#" active={(module==='consultorio') ? true : false}
          onClick={
            (e) => {
              this.initsetState({
                module:'consultorio'
              })
            }
          }
          >Consultorio</Nav.ItemLink>
        </Nav>
        <hr style={{marginTop:'-2px',border:'1px solid #c5c5c5'}}/>
        
        <div className="mb-1">
          <div className="row">
            <div className="mb-3 col-sm-2">
              <input type="date" value={finit} className="form-control"
                onChange={(event) => {
                  arrFiltroVer.map(( t => t.active = 0) );
                  this.setState({ finit: event.target.value, arrFiltroVer });
                }}              
              />
            </div>

            <div className="mb-3 col-sm-2">
              <input type="date" value={ffin} className="form-control"
                onChange={(event) => {
                  arrFiltroVer.map(( t => t.active = 0) );
                  this.setState({ ffin: event.target.value, arrFiltroVer });
                }}              
              />
            </div>

            <div className="mb-3 col-sm-2">
              <button onClick={() => { this.getInfo() }} className="btn btn-primary">Buscar</button>
            </div>
          </div>
        </div>

        <Row>
          <Col sm={6} md={4} lg={2} className="text-left">
            <div className="ws-box-content">
              <h4>Ventas Netas</h4>
              <p className="ws-box-price">$ {this.nf(arrHistoryVentas.total)}</p>
              <p className="ws-box-up-sales"><span><img src={'img/pos2/arrow-up.svg'} /></span> 0%</p>
              <p className="ws-box-total-sales">Mes anterior ${this.nf(arrHistoryVentas.total_ant)}</p>
              <hr />
              {/*<p className="ws-box-details mb-2">Ver detalle</p>*/}
            </div>
          </Col>

          <Col sm={6} md={4} lg={2}className="text-left">
            <div className="ws-box-content">
              <h4>Costo de ventas</h4>
              <p className="ws-box-price">$ {this.nf(arrHistoryVentas.total_pcompra)}</p>
              <p className="ws-box-up-sales red"><span><img src={'img/pos2/arrow-up.svg'} /></span> 0%</p>
              {/*<p className="ws-box-total-sales">Mes anterior ${this.nf(arrHistoryVentas.total_pcompra_ant)}</p>*/}
              <hr />
              {/*<p className="ws-box-details mb-2">Ver detalle</p>*/}
            </div>
          </Col>

          <Col sm={6} md={4} lg={2} className="text-left">
            <div className="ws-box-content">
              <h4>Utilidad Bruta</h4>
              <p className="ws-box-price">$ { this.nf(arrHistoryVentas.total - arrHistoryVentas.total_pcompra) }</p>
              <p className="ws-box-up-sales"><span><img src={'img/pos2/arrow-up.svg'} /></span> 0%</p>
              <p className="ws-box-total-sales"></p>
              <hr />
              {/*<p className="ws-box-details mb-2">Ver detalle</p>*/}
            </div>
          </Col>

          <Col sm={6} md={4} lg={2} className="text-left">
            <div className="ws-box-content">
              <h4>Gastos</h4>
              <p className="ws-box-price">$ {this.nf(arrHistoryVentas.gastos)}</p>
              <p className="ws-box-up-sales"><span><img src={'img/pos2/arrow-up.svg'} /></span> 0%</p>
              <p className="ws-box-total-sales"></p>
              <hr />
              {/*<p className="ws-box-details mb-2">Ver detalle</p>*/}
            </div>
          </Col>

          <Col sm={6} md={4} lg={2} className="text-left">
            <div className="ws-box-content">
              <h4>Utilidad</h4>
              <p className="ws-box-price">$ {this.nf(arrHistoryVentas.utilidad)}</p>
              <p className="ws-box-up-sales"><span><img src={'img/pos2/arrow-up.svg'} /></span> 0%</p>
              <p className="ws-box-total-sales">antes de impuestos</p>
              <hr />
              {/*<p className="ws-box-details mb-2">Ver detalle</p>*/}
            </div>
          </Col>

          <Col sm={12}>
            <Row>
              <Col sm={12} md={12} lg={12}>
                <Row>
                  <Col sm={4} md={4} lg={4} className="text-left">
                    <div className="ws-box-content">
                      <h4>Clientes</h4>
                      <p className="ws-box-price">0</p>
                      <p className="ws-box-up-sales"><span><img src={'img/pos2/arrow-up.svg'} /></span> 0%</p>
                      <p className="ws-box-total-sales">Ticket promedio: $0</p>
                      <hr />
                      {/*<p className="ws-box-details mb-2">Ver detalle</p>*/}
                    </div>
                  </Col>

                  <Col sm={4} md={4} lg={4} className="text-left">
                    <div className="ws-box-content">
                      <h4>Caja</h4>
                      <p className="ws-box-price">$ {this.nf( arrHistoryVentas.utilidad_neta + cantidadDisponible )}</p>
                      {/*<p className="ws-box-up-sales"><span><img src={'img/pos2/arrow-up.svg'} /></span> 0%</p>*/}
                      <hr />
                      {/*<p className="ws-box-details mb-2">Ver detalle</p>*/}
                    </div>
                  </Col>
                  <Col sm={4} md={4} lg={4} className="text-left">
                    <div className="ws-box-content">
                      <h4>Ventas a domicilio</h4>
                      <p className="ws-box-price">$ 0</p>
                      <p className="ws-box-up-sales"><span><img src={'img/pos2/arrow-up.svg'} /></span> 0%</p>
                      <p className="ws-box-total-sales">Total de ventas: 0</p>
                      <hr />
                      {/*<p className="ws-box-details mb-2">Ver detalle</p>*/}
                    </div>
                  </Col>

                </Row>
              </Col>
              <Col sm={12} md={12} lg={6}>
                <div className="ws-box-content">
                  <h4 className="mb-4">Ventas por fecha</h4>
                  <div className="table-responsive">
                    <table className="table table-sm table-striped mt-2">
                      <thead>
                        <tr>
                          <th>Producto</th>
                          <th>Piezas/KG</th>
                          <th>Total venta</th>
                          <th>Total compra</th>
                          <th>Utilidad bruta</th>
                          <th>Fecha</th>
                          <th>Opción</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          arrHistoryProductosVenta.map((t,e) => (
                            <tr>
                              <td>{t.nombre}</td>
                              <td>{this.nf(t.venta_kg)}</td>
                              <td>${this.nf(t.venta_pesos * t.venta_kg)}</td>
                              <td>${this.nf(t.venta_pcompra * t.venta_kg)}</td>
                              <td>${this.nf((t.venta_pesos * t.venta_kg) - (t.venta_pcompra * t.venta_kg))}</td>
                              <td>{t.hora}</td>
                              <td onClick={() => { this.setDeleteVentaByID(t) }}><b className={'text text-danger'} style={{ cursor: 'pointer', }}>Eliminar</b></td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                  </div>
                  <hr />
                  {/*<p className="ws-box-details mb-2">Ver detalle</p>*/}
                </div>
              </Col>


              <Col sm={12} md={12} lg={6}>
                <div className="ws-box-content">
                  <h4 className="mb-4">Movimientos de caja</h4>
                  <div className="table-responsive">
                    <table className="table table-sm table-striped mt-2">
                      <thead>
                        <tr>
                          <th>Concepto</th>
                          <th>Monto</th>
                          <th>Hora</th>
                          <th>Opción</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          arrHistoryCaja.map((t,e) => (
                            <tr>
                              <td>{t.nombre}</td>
                              <td>${this.nf(t.valor)}</td>
                              <td>{t.hora}</td>
                              <td><b className={'text text-danger'} style={{ cursor: 'pointer', }} onClick={() => { this.setDeleteCaja(t) }}>Eliminar</b></td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                  </div>
                  <hr />
                  <button className="ws-box-details mb-2 btn btn-primary" onClick={() => { this.setState({ viewRegisterCaja: !viewRegisterCaja, }) }}>Nuevo movimiento de caja</button>
                  {
                    viewRegisterCaja ? (
                      <Row>
                        <Col xs={3}>
                          <select
                            style={{ padding: 5, background: '#f3f3f3', border: 0, }}
                            onChange={(event) => { arrRegisterCaja.concepto = event.target.value; this.setState({ arrRegisterCaja, }) }}
                          >
                            <option value={'0'} disabled={'disabled'} selected={'selected'}>Selecciona un concepto</option>
                            <option value={'1'}>Apertura del día</option>
                            <option value={'2'}>Reingreso en caja</option>
                            {/*<option value={'3'}>Gasto general diario</option>*/}
                            <option value={'4'}>Salida de dinero de tienda</option>
                            <option value={'5'}>Salida de dinero de citas</option>
                          </select>
                        </Col>
                        <Col>
                          <input
                            style={{ width: '100%', padding: 4, background: '#e7e7e7', border: '1px solid #c3c3c3', borderRadius: 4, }}
                            value={arrRegisterCaja.cantidad} placeholder={'Ingresa una cantidad'} type={'number'}
                            onChange={(event) => { arrRegisterCaja.cantidad = event.target.value; this.setState({ arrRegisterCaja }) }}
                          />
                          <input
                            style={{ width: '100%', padding: 4, background: '#e7e7e7', border: '1px solid #c3c3c3', borderRadius: 4, }}
                            value={arrRegisterCaja.date} placeholder={'Ingresa la fecha'} type={'date'}
                            onChange={(event) => { arrRegisterCaja.date = event.target.value; this.setState({ arrRegisterCaja }) }}
                          />
                          {
                            arrRegisterCaja.concepto === '3' ? (
                              <textarea
                                placeholder={'Ingresa una observación del retiro'}
                                onChange={(event) => { arrRegisterCaja.observacion = event.target.value; this.setState({ arrRegisterCaja }); }}
                                value={arrRegisterCaja.observacion}
                                style={{ width: '100%', border: 1, backgroundColor: '#f3f3f3', padding: 4, borderRadius: 4, minHeight: 100, }}
                              >
                              </textarea>
                            ) : null
                          }
                        </Col>
                        <Col xs={2}>
                          <button className={'btn btn-secondary'} onClick={() => { this.setRegisterNewCaja() }}>Registrar</button>
                        </Col>
                      </Row>
                    ) : null

                  }
                  <hr />


                </div>
              </Col>

              <Col sm={12} md={12} lg={6}>
                <div className="ws-box-content">
                  <h4 className="mb-4">INVENTARIO REGISTRADO</h4>
                  <input type="date" value={finit_inventario} className="form-control"
                    onChange={(event) => {
                      this.setState({ finit_inventario: event.target.value, updateInventory: true, });
                    }}
                  />
                  {
                    updateInventory ? <button
                      onClick={() => {
                        this.setState({ updateInventory: false, })
                        fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=getStockInventario", {
                          method: "POST",
                          mode: "cors",
                          body: JSON.stringify({
                            fecha_init: finit_inventario,
                          }),
                        })
                        .then(response => response.json())
                        .then((response) => {
                          let { productos, categorias, } = response
                          this.setState({ arrCategoriasInventario: categorias, })
                        }).catch((error) => {})

                      }}
                      className={'btn btn-primary'}>Actualizar</button>
                    : null
                  }
                  <div className="table-responsive">
                  {
                    arrCategoriasInventario.map((t0, e0) => {

                      if(t0.list.length == 0) {

                        return (
                          <div className={'ws__list_categorias_almacen'}>
                            <Row className={`ws__list_categorias_almacen_p ${(t0.show && t0.list.length > 0) ? 'active' : ''}`}>
                              <Col style={{backgroundColor:'#8c6164',aligItems:'center'}}>
                                <p style={{color:'#fff',fontWeight:'500', margin: 10, }}>{t0.nombre}</p>
                              </Col>
                              <Col style={{backgroundColor:'#8c6164'}}>
                                <p style={{ fontSize: '.8rem', textAlign: 'right', color:'#fff',fontWeight:'500', margin: 10, }}>({this.nf(t0.list.length, 0)}) productos</p>
                              </Col>
                            </Row>
                            <p>Esta categoría no tiene productos con inventario</p>
                          </div>
                        )

                      } else {
                        return (
                          <div className={'ws__list_categorias_almacen'}>
                            <Row className={`ws__list_categorias_almacen_p ${(t0.show && t0.list.length > 0) ? 'active' : ''}`} onClick={() => { this.onExpandSectionCate(t0, e0) }}>
                              <Col style={{backgroundColor:'#8c6164',aligItems:'center'}}>
                                <p style={{color:'#fff',fontWeight:'500', margin: 10, }}>{t0.nombre}</p>
                              </Col>
                              <Col style={{backgroundColor:'#8c6164'}}>
                                <p style={{ fontSize: '.8rem', textAlign: 'right', color:'#fff',fontWeight:'500', margin: 10, }}>({this.nf(t0.list.length, 0)}) productos</p>
                              </Col>
                            </Row>
                            {
                              t0.show && t0.list.length > 0 ? (
                                <div className={'ws__searchcnt'}>
                                  <input
                                    className="mt-2 mb-2"
                                    type={'text'}
                                    onChange={(event) => { this.setState({ valSeach: event.target.value }) }}
                                    placeholder={'Buscar un producto...'}
                                    style={{ width: '100%', border: 0, backgroundColor: '#f3f3f3', padding: 4, borderRadius: 4, }}
                                  />
                                </div>
                              ) : null
                            }
                            <table className="table table-bordered table-hover table-sm">
                              <thead>
                                <tr>
                                  <th >Nombre</th>
                                  <th style={{ textAlign: 'center', }}>Cantidad en sistema</th>
                                  <th style={{ textAlign: 'center', }}>Cantidad confirmada</th>
                                  {/*<th style={{ textAlign: 'center', }}>Diferencia</th>*/}
                                </tr>
                              </thead>
                              <tbody>
                                {
                                  t0.list.map((t, e) => (
                                    <tr key={"item_" + e} style={{ cursor: 'pointer', }}>
                                      <td><p style={{ padding: '0', margin: '0' }}>{t.nombre}</p></td>
                                      <td style={{ textAlign: 'center', }}><p>{this.nf(t.cantidad_sistema, 2)}</p></td>
                                      <td style={{ textAlign: 'center', }}><p>{this.nf(t.cantidad_confirmada, 2)}</p></td>
                                      {/*<td style={{ textAlign: 'center', }}><p>{this.nf(t.cantidad_sistema - t.cantidad_confirmada, 2)}</p></td>*/}
                                    </tr>
                                  ))
                                }
                              </tbody>
                            </table>
                          </div>
                        )
                      }


                    })
                  }
                  </div>
                  <hr />
                  {/*<p className="ws-box-details mb-2">Ver detalle</p>*/}
                </div>
              </Col>

              <Col sm={12} md={12} lg={6}>
                <div className="ws-box-content">
                  <h4 className="mb-4">ALMACEN</h4>
                  <button style={{ cursor: 'pointer' }} className={'btn btn-sadett-flat'} onClick={() => { this.setState({ viewTableType: viewTableType == 'KG/PZA.' ? 'PESOS' : 'KG/PZA.' }) }}>VISTA: {viewTableType.toUpperCase()}</button>
                  <div className="table-responsive">
                  {
                    arrCategorias.map((t0, e0) => (
                      <div className={'ws__list_categorias_almacen'}>
                        <Row className={`ws__list_categorias_almacen_p ${(t0.show && t0.list.length > 0) ? 'active' : ''}`} onClick={() => { this.onExpandSectionCate(t0, e0) }}>
                          <Col style={{backgroundColor:'#8c6164',aligItems:'center'}}>
                            <p style={{color:'#fff',fontWeight:'500', margin: 10, }}>{t0.nombre}</p>
                          </Col>
                          <Col style={{backgroundColor:'#8c6164'}}>
                            <p style={{ fontSize: '.8rem', textAlign: 'right', color:'#fff',fontWeight:'500', margin: 10, }}>({this.nf(t0.list.length, 0)}) productos</p>
                          </Col>
                        </Row>
                        {
                          t0.show && t0.list.length > 0 ? (
                            <div className={'ws__searchcnt'}>
                              <input
                                className="mt-2 mb-2"
                                type={'text'}
                                onChange={(event) => { this.setState({ valSeach: event.target.value }) }}
                                placeholder={'Buscar un producto...'}
                                style={{ width: '100%', border: 0, backgroundColor: '#f3f3f3', padding: 4, borderRadius: 4, }}
                              />
                            </div>
                          ) : null
                        }
                        {
                          t0.show && t0.list.length > 0 && viewTableType === 'KG/PZA.' ? (
                            <table className="table table-bordered table-hover table-sm">
                              <thead>
                                <tr>
                                  <th >Nombre</th>
                                  <th style={{ textAlign: 'center', }}>Adquisiciones de hoy</th>
                                  <th style={{ textAlign: 'center', }}>Ventas de hoy</th>
                                  <th style={{ textAlign: 'center', }}>Existencia</th>
                                </tr>
                              </thead>
                              <tbody>
                                {
                                  t0.list.map((t, e) => (
                                    <>
                                      {
                                        /*
                                        valSeach === '' ||
                                          t.nombre.trim().toLowerCase().indexOf(valSeach.toLowerCase()) !== -1 ? (
                                          */
                                          <tr key={"item_" + e} onClick={() => this.onLoadInfoByDay(t, e)} style={{ cursor: 'pointer', }}>
                                            <td><p style={{ padding: '0', margin: '0' }}>{t.nombre}</p></td>
                                            <td style={{ textAlign: 'center', }}><p>{this.nf(t.day_compra_kg, 2)}</p></td>
                                            <td style={{ textAlign: 'center', }}><p>{this.nf(t.day_venta_kg, 2)}</p></td>
                                            <td style={{ textAlign: 'center', }}><p>{this.nf(t.history_entradas - t.venta_kg, 2)}</p></td>
                                          </tr>
                                          /*
                                        ) : null
                                      */
                                      }
                                    </>
                                  ))
                                }
                              </tbody>
                            </table>
                          ) : null
                        }
                        {
                          t0.show && t0.list.length > 0 && viewTableType === 'PESOS' ? (
                            <table className="table table-bordered table-hover table-sm">
                              <thead>
                                <tr>
                                  <th >Nombre</th>
                                  <th style={{ textAlign: 'center', }}>Adquisiciones de hoy</th>
                                  <th style={{ textAlign: 'center', }}>Ventas de hoy</th>
                                  <th style={{ textAlign: 'center', }}>Cantidad global</th>
                                </tr>
                              </thead>
                              <tbody>
                                {
                                  t0.list.map((t, e) => (
                                    <>
                                      {
                                        valSeach === '' ||
                                          t.nombre.trim().toLowerCase().indexOf(valSeach.toLowerCase()) !== -1 ? (
                                          <tr key={"item_" + e} onClick={() => this.onLoadInfoByDay(t, e)}>
                                            <td><p style={{ padding: '0', margin: '0' }}>{t.nombre}</p></td>
                                            <td style={{ textAlign: 'center', }}><p>${this.nf(t.day_compra_pesos, 2)}</p></td>
                                            <td style={{ textAlign: 'center', }}><p>${this.nf(t.day_venta_pesos, 2)}</p></td>
                                            <td style={{ textAlign: 'center', }}><p>${this.nf(t.venta_pesos - t.compra_pesos, 2)}</p></td>
                                          </tr>
                                        ) : null
                                      }
                                    </>
                                  ))
                                }
                              </tbody>
                            </table>
                          ) : null
                        }
                      </div>
                    ))
                  }
                  </div>
                  <hr />
                  {/*<p className="ws-box-details mb-2">Ver detalle</p>*/}
                </div>
              </Col>

            </Row>
          </Col>

          <Col sm={12}>
            <Row>
              <Col sm={12} md={12} lg={12}>
                <div className="ws-box-content">
                  <h4>Volumen total de ventas</h4>
                  <p className="ws-box-price">$ {this.nf(arrHistoryVentas.utilidad)}</p>
                  <p className="ws-box-up-sales"><span><img src={'img/pos2/arrow-up.svg'} /></span> 20%</p>
                  <div style={{height:450, width:'100%'}}>
                    <ResponsiveLine
                    data={data}
                    margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
                    xScale={{ type: 'point' }}
                    yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: true, reverse: false }}
                    yFormat=" >-.2f"
                    curve="monotoneX"
                    axisTop={null}
                    axisRight={null}
                    axisBottom={{
                      orient: 'bottom',
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: 0,
                      legend: 'transportation',
                      legendOffset: 36,
                      legendPosition: 'middle'
                    }}
                    axisLeft={{
                        orient: 'left',
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: 'count',
                        legendOffset: -40,
                        legendPosition: 'middle'
                    }}
                    colors= {['#8c6164','#7ac943']}
                    enableGridX={false}
                    lineWidth={3}
                    // enablePoints={false}
                    // pointSize={4}
                    pointColor={{ theme: 'background' }}
                    // pointBorderWidth={2}
                    pointBorderColor={{ from: 'serieColor' }}
                    pointLabelYOffset={-12}
                    useMesh={true}
                    />
                  </div>
                  <hr />
                  {/*<p className="ws-box-details mb-2">Ver detalle</p>*/}
                </div>
              </Col>

            </Row>
          </Col>


        </Row>
      </div>
    )
  }

  setDeleteVentaByID(t) {
    var opcion = window.confirm("¿Estás seguro que deseas eliminar esta orden?");
    if (opcion == true) {
      const { id_produccion, } = t
      fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=setDeleteVentaByID", this.headersPOST({ id_produccion, }))
      .then(response => response.json())
      .then((response) => {
        alert('Orden eliminada con éxito')
        this.getInfo()
      })
    }
  }

  setDeleteCaja(t) {
    var opcion = window.confirm("¿Estás seguro que deseas eliminar este movimiento?");
    if (opcion == true) {
      const { id_corte, } = t
      fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=setDeleteCaja", this.headersPOST({ id_corte, }))
      .then(response => response.json())
      .then((response) => {
        this.getInfo()
      })
    }
  }

  onExpandSectionCate(t, e) {
    let { arrCategorias, } = this.state
    arrCategorias[e].show = !arrCategorias[e].show
    this.setState({ arrCategorias, valSeach: '', })
  }

  setRegisterNewCaja() {
    const { arrRegisterCaja, } = this.state

    if (arrRegisterCaja.concepto < 1) {
      alert('Por favor, define un concepto.')
      return false
    } else if (arrRegisterCaja.cantidad === '' || arrRegisterCaja.cantidad === 0) {
      alert('Por favor, ingresa una cantidad.')
      return false
    }

    if (arrRegisterCaja.concepto === '3' && arrRegisterCaja.observacion === '') {
      alert('Por favor, registra una observación.')
      return false
    }

    fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp?opt=setRegisterNewCaja", this.headersPOST({ arrRegisterCaja }))
      .then(response => response.json())
      .then((response) => {
        // console.log( response )
        this.setState({
          arrRegisterCaja: {
            date: moment().format('YYYY-MM-DD'),
            concepto: 0,
            cantidad: '',
            observacion: '',
          },
          viewRegisterCaja: false,
        })
        this.getInfo()
      })
  }

  initsetState(param) {
    this.props.initsetState(param)
    return true
  }

  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

  nf(number, decimals, decPoint, thousandsSep) {
    number = (number+'').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return ''+(Math.round(n * k) / k)
      .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : ''+Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length+1).join('0')
    }
    return s.join(dec)
  }

}

export default MainContainer;